<template>
  <add-edit-document></add-edit-document>
</template>

<script>
import AddEditDocument from "@/layouts/components/consultant-detail/Documents/addEdit-document";
export default {
  components: {
    AddEditDocument
  }
};
</script>
